import { Controller } from "@hotwired/stimulus"

// The Page Banner's main action for a React data table (#18893): the HAML
// banner and the React island are separate trees, so the button asks the
// table to open its create popup with a document event naming the table.
// The React twin is usePageBannerCreateTrigger (same event name).
//
// Wire: data-controller="open-create-modal"
//       data-open-create-modal-table-value="team-members-datatable"
//       data-action="open-create-modal#open"
export const OPEN_CREATE_MODAL_EVENT = "gl:open-create-modal"

export default class extends Controller {
  static values = { table: String }

  open(event) {
    event?.preventDefault()
    document.dispatchEvent(new CustomEvent(OPEN_CREATE_MODAL_EVENT, { detail: { table: this.tableValue } }))
  }
}
